import clsx from "clsx";
import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from "react";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: ReactNode;
  hint?: ReactNode;
  containerClassName?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, hint, containerClassName, className, id, ...rest },
  ref,
) {
  const generated = useId();
  const inputId = id ?? generated;
  return (
    <div className={clsx("flex items-start gap-2", containerClassName)}>
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        aria-describedby={hint ? `${inputId}-hint` : undefined}
        className={clsx(
          "mt-0.5 h-4 w-4 shrink-0 rounded border-ink-400 text-accent-700 focus:ring-accent-500 dark:border-ink-600 dark:bg-ink-900",
          className,
        )}
        {...rest}
      />
      <div>
        <label htmlFor={inputId} className="text-sm text-ink-800 dark:text-ink-100">
          {label}
        </label>
        {hint && (
          <p id={`${inputId}-hint`} className="text-xs text-ink-500 dark:text-ink-400">
            {hint}
          </p>
        )}
      </div>
    </div>
  );
});
